"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const styles_1 = require("../styles");
exports.Form = styled_components_1.default.form `
  align-items: flex-start;
  display: flex;
  color: ${({ theme }) => theme.colors.darkred};
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;

  > fieldset {
    color: ${({ theme }) => theme.colors.red};
  }

  > button {
    flex-grow: 2;
    margin: 0 ${(0, styles_1.vw)(4.25, 'mobile')} ${(0, styles_1.vw)(4.25, 'mobile')};

    ${styles_1.mq.greaterThan('nexus7')} {
      margin: 0 ${(0, styles_1.vw)(4.5, 'nexus7')} ${(0, styles_1.vw)(4.5, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      margin: 0 ${(0, styles_1.vw)(12.5, 'desktop')} ${(0, styles_1.vw)(12.5, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      margin: 0 12.5px 12.5px;
    }
  }

  > .subtext {
    ${(0, styles_1.getP15_2)()}
    color: ${({ theme }) => (0, styles_1.hex2Rgba)(theme.colors.darkred, .5)};
    margin-top: ${(0, styles_1.vw)(30, 'mobile')};
    text-align: center;
    width: 100%;

    ${styles_1.mq.greaterThan('nexus7')} {
      margin-top: ${(0, styles_1.vw)(30, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      margin-top: ${(0, styles_1.vw)(50, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      margin-top: 50px;
    }

    a,
    button {
      ${(0, styles_1.getP15_2)()}
      color: inherit;
      transition: 300ms color ease-out;
      text-decoration: underline;

      &:hover {
        color: ${({ theme }) => (0, styles_1.hex2Rgba)(theme.colors.darkred, 1)};
      }
    }
  }
`;
